import ShipType from "@/model/ShipType";
import IceClassType from "@/model/IceClassType";
import Configuration from "./Configuration";
import Crane from "./Crane";
import CarbonElementType from "./CarbonElementType";
import FuelType from "./FuelType";
import FuelConsum from "./FuelConsum";
import { CIIArrayData, ETSArrayData, FuelEUArrayData, ETSExtraData, FuelEUExtraData}  from "./Neobuq/NeobuqArrayData"
import {NeobuqModification} from "./Neobuq/NeobuqModifications"
import NeobuqCarbonData from "./Neobuq/NeobuqCarbonData"
import NeobuqFuelEUData from "./Neobuq/NeobuqFuelEUData";

class Ship {
    public id: string = ""
    public imo: string = ""
    public name: string = ""
    public requiredEEXI: number = 0
    public attainedEEXI: string = ""
    public shipType: ShipType = new ShipType()
    public shipTypeStr: string = ""
    public iceClassType: IceClassType = new IceClassType();

    public keelLaidDownDate: Date = new Date()
    public contractSignInDate: Date = new Date()
    public shipDeliveredDate: Date = new Date()
    
    public gt: number = 0
    public dwt: number = 0
    public lpp: number = 0
    public loa: number = 0
    public cb: number = 0
    public manualVref: number = 0
    public speedPowerTests: boolean = false
    public dwtsService: number = 0
    public psService: number = 0
    public vsService: number = 0
    public bs: number = 0
    public ds: number = 0

    public displacementVolume: number = 0

    public has_vse: boolean = false
    public lwtReferenceDesign: number = 0
    public lwtEnhancedDesign: number = 0
    public capacity: number = 0
    public capacityCorrection: number = 0

    public cranes: Array<Crane> = []

    public has_sideloaders: boolean = false
    public capacityNoSideloaders: number = 0
    public capacitySideloaders: number = 0

    public has_roro_ramps: boolean = false
    public capacityNoRORORamp: number = 0
    public capacityRORORamp: number = 0

    public structuralEnhancement: boolean = false
    
    public has_csr: boolean = false
    public lwtCsr: number = 0
    public dwtCsr: number = 0

    public vTanks: number = 0
    
    public fc: number = 0
    public fi_csr: number = 0
    public fi_ice: number = 0
    public fi_vse: number = 0

    public highSpeedCruise: boolean = false

    public configurations: Array<Configuration> = new Array<Configuration>()

    public carbonData: CarbonElementType = new CarbonElementType()

    //VARIABLES QUE USAREMOS EN NEOBUQ. Habrá datos (como los usados para el CII antiguo) que estén en otros modelos pero que los
    //incluiremos aquí para más facilidad de acceso. Como son dos aplicaciones separadas, no se van a solapar datos
    //para almacenar los tipos de combustible y su respectivo consumo de cada barco
    public fuelConsumption : Array<FuelConsum> = new Array<FuelConsum>()
    public totalDistance : number = 0

    public oldPrewrittenCII : {[key: string]: number} = {}
    public oldAttainedCII : number = 0

    public isNEOBUQ : boolean = false //nos indica si el barco se ha creado para ECOBUQ o NEOBUQ

    //CII
    public anualPrewrittenCII : {[key: string]: number} = {}
    //HACER ARRAYS DE CII, FuelEU Y ETS PARA CADA AÑO; CADA VEZ QUE HAGAMOS ESE CÁLCULO, LO HACEMOS PARA TODOS LOS AÑOS
    //ponemos 'base' porque serán las medidas del caso base; para las modificaciones será diferente
    public baseCII : Array<CIIArrayData> = new Array<CIIArrayData>()
    public baseETS : Array<ETSArrayData> = new Array<ETSArrayData>()
    public baseFuelEU : Array<NeobuqFuelEUData> = new Array<NeobuqFuelEUData>()

    //para mostrarlos en la pantalla principal de NEOBUQ
    public selectedBaseCII : string = "" //será la letra
    public selectedBaseFuelEU : number = 0
    public selectedBaseETS : number = 0

    //pasamos a las modificaciones, cada barco tendrá una lista de modificaciones
    public modifications : Array<NeobuqModification> = new Array<NeobuqModification>()

    //para las modificaciones, necesitamos más datos sobre el CII, ETS y FuelEU
    public dataForCII : NeobuqCarbonData = new NeobuqCarbonData()
    public dataForETS : ETSExtraData = new ETSExtraData() 
    public dataForFuelEU : FuelEUExtraData = new FuelEUExtraData()

}

export default Ship